import React from 'react';
import styled, { css } from 'styled-components';
import tw from 'tailwind.macro';

export default ({ local }) => {
  let status = 'Estado: Cerrado';

  if (local.abierto) {
    status = local.is24h ? 'Farmacia 24 hrs' : 'Estado: Abierto';
  }

  return (
    <Container>
      <Address>{local.direccion}</Address>
      <OpeningHours>
        Lunes a Viernes:
        {' '}
        {local.lv}
        <br />
        Sábado:
        {' '}
        {local.sa}
        <br />
        Domingo:
        {' '}
        {local.do}
      </OpeningHours>
      <StatusContainer open={local.abierto} is24h={local.is24h}>
        <Status>
          { status }
        </Status>
        {/* <Distance>
          {local.distance}
          {' '}
          kms
        </Distance> */}
      </StatusContainer>
    </Container>
  );
};

const Container = styled.div``;

const Address = styled.div`
  ${tw`
    font-bold mr-4
  `};
`;

const OpeningHours = styled.div`
  ${tw`
    my-3
  `};
`;

const StatusContainer = styled.div`
  background-color: #00953B;

  ${tw`
    flex justify-between text-white px-2 py-1 font-bold
  `};

  ${(props) => !props.open && css`
    background-color: #AAAAAA;
  `}

  ${(props) => props.is24h && css`
    background-color: #FCD329;
    color: #00953B;
    font-weight: bold;
  `}
`;

const Status = styled.div`
`;

const Distance = styled.div`
`;
